import { useState, useEffect, useCallback } from 'react'
import { onReLoginSuccess as interceptorReLoginSuccess } from '@/lib/auth-interceptor'
import type { AuthResponse } from '@/types/api'

export function useSessionExpired() {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const handler = () => setIsOpen(true)
    window.addEventListener('session-expired', handler)
    return () => window.removeEventListener('session-expired', handler)
  }, [])

  const handleReLoginSuccess = useCallback(
    (data: AuthResponse) => {
      interceptorReLoginSuccess(data)
      setIsOpen(false)
    },
    [],
  )

  const handleExit = useCallback(() => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')
    window.location.href = '/login'
  }, [])

  return { isOpen, handleReLoginSuccess, handleExit }
}
